import React, { useState } from "react"
import { Flex, Link, useAuthenticator } from "@aws-amplify/ui-react"
import { useConfig } from "../../configuration/useConfig"
import IdpSignInButton from "./IdpSignInButton"

const SignInFooter = () => {
  const { toForgotPassword } = useAuthenticator()
  const {config} = useConfig()
  const [error, setError] = useState<string | null>(null)

  return (
    <Flex direction="column" gap={"0.75rem"}>
      {config.idpProviders.map(provider => {
        return (
          <IdpSignInButton providerName={provider.name} setError={setError} key={provider.name}></IdpSignInButton>
      )})}
      {error ? (
        <span style={{ color: "#fff", fontSize: "0.9rem" }}>{error}</span>
      ) : null}
      <Link onClick={toForgotPassword}>Forgot your password?</Link>
    </Flex>
  )
}

export default SignInFooter
